import { AnalyticsItem, analyticsManager } from './AnalyticManager';
import Amplitude from './vendors/Amplitude';

const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY || null;

if (AMPLITUDE_API_KEY) {
  const amplitude: AnalyticsItem = new Amplitude(AMPLITUDE_API_KEY);
  analyticsManager.addSubscriber(amplitude);
}

export default analyticsManager;
